import { Star, Sparkles, Layers, Ban } from 'lucide-react';
import { cn } from '@/lib/utils';
import { CatalogPlan, planAudiences } from '@/client/types/promotion-pricing/catalog';

interface PlanFlagsProps {
  plan: CatalogPlan;
  className?: string;
}

const chip = 'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium';

/** Compact badge row summarising a plan's flags and audience. */
export const PlanFlags = ({ plan, className }: PlanFlagsProps) => {
  const audiences = planAudiences(plan);

  return (
    <div className={cn('flex flex-wrap items-center gap-1.5', className)}>
      {!plan.active && (
        <span className={cn(chip, 'bg-gray-100 text-gray-500')}>
          <Ban className="h-3 w-3" /> Inactive
        </span>
      )}
      {!!plan.popular && (
        <span className={cn(chip, 'bg-amber-50 text-amber-700')}>
          <Star className="h-3 w-3 fill-amber-400 text-amber-400" /> Popular
        </span>
      )}
      {!!plan.featured && (
        <span className={cn(chip, 'bg-blue-50 text-blue-700')}>
          <Sparkles className="h-3 w-3" /> Featured
        </span>
      )}
      {!!plan.stackable && (
        <span className={cn(chip, 'bg-violet-50 text-violet-700')}>
          <Layers className="h-3 w-3" /> Stackable
        </span>
      )}
      {audiences.map((a) => (
        <span key={a} className={cn(chip, 'bg-gray-100 text-gray-600')}>
          {a}
        </span>
      ))}
    </div>
  );
};
